"use client"

import clsx from "clsx"
import NextImage from "next/image"
import { useImageConfiguration } from "@/contexts/image-configuration/image-configuration.context"
import type { ArticleContentModel } from "@/services/api/content/models/article-content-model.types"
import { imageLoader } from "@/utilities/image/image-loader"

type SupportingFeatureImageProps = {
  readonly image: ArticleContentModel.SupportingImage
  readonly sourceSetSize: string
  readonly className?: string
}

export function SupportingFeatureImage({
  image,
  sourceSetSize,
  className,
}: SupportingFeatureImageProps) {
  const { serverUrl } = useImageConfiguration()

  return (
    <figure className="relative">
      <div className="relative left-1/2 aspect-3/2 w-screen -translate-x-1/2 lg:w-full">
        <NextImage
          alt={image.caption ?? ""}
          className={clsx(className, "bg-whisper object-cover")}
          fill={true}
          loader={imageLoader(serverUrl)}
          priority={true}
          sizes={sourceSetSize}
          src={image.aspectRatio3By2}
        />
      </div>
      <figcaption className="absolute right-0 bottom-0 3xl:block hidden w-1/5 translate-x-[100%] px-1.5 text-dim text-sm">
        <div className="wrap-break-word hyphens-manual">{image.caption}</div>
      </figcaption>
      <figcaption className="mx-auto mt-1 3xl:hidden max-w-full text-dim md:max-w-prose">
        <div className="wrap-break-word hyphens-manual text-xs sm:text-sm">
          {image.caption}
        </div>
      </figcaption>
    </figure>
  )
}
